import React, { Component } from "react"
import "./loading.scss"

class Loading extends Component {
  render() {
    return (
      <div className="center">
        <div className="lds-default">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <h3 className="loading-text">Fetching data...</h3>
      </div>
    )
  }
}

export default Loading
